import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RecordIcon.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconProps {
  record: any;
  index: number;
  handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const RecordIcon: React.FC<RecordIconProps> = ({ record, index, handleLinkClick }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  let imageUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}images/nondisponible.cci&width=240&height=160&bg=ffffff`;
  const allImages = getImages(record);
  if ((allImages as any)["icon"]?.length > 0) {
    imageUrl = (allImages as any)["icon"][0]?.url;
  }

  const invNo = record?.data?.Record?.ObjectNumber;

  function dataIcon(record: any) {
    const titleData = record?.data?.record?.title?.title;
    const objectNrData = record?.data?.record?.objectnumber;
    const sitename = record?.data?.record?.sitename;
    const lastName = record?.data?.record?.lastname;
    const firstName = record?.data?.record?.firstname;
    const nationality = record?.data?.record?.nationality;
    const conDate = record?.data?.record?.condated;
    const eventName = record?.data?.record?.eventname;
    const exhTitle = record?.data?.record?.exhtitle;
    const institution = record?.data?.record?.institution;
    const institutions = record?.data?.record?.institutions;

    // ✅ Nieuwe velden
    const displayName = record?.data?.record?.displayname;
    const displayDate = record?.data?.record?.displaydate;

    if (
      !objectNrData &&
      !institution &&
      !institutions &&
      !titleData &&
      !sitename &&
      !lastName &&
      !firstName &&
      !nationality &&
      !conDate &&
      !eventName &&
      !exhTitle &&
      !displayName &&
      !displayDate
    ) {
      return <div className={styles.row}>{t("No information available")}</div>;
    }

    return (
      <div className={styles.row}>
        {objectNrData && <>{objectNrData}<br /><br /></>}
        {institution && <>{institution}<br /><br /></>}
        {institutions && <>{institutions}<br /><br /></>}
        {titleData && <>{titleData}<br /></>}
        {sitename && <>{sitename}<br /></>}
        {conDate && <>{conDate}<br /></>}
        {eventName && <>{eventName}<br /></>}
        {exhTitle && <>{exhTitle}<br /></>}
        
        {/* ✅ Nieuwe velden toegevoegd */}
        {displayName && (
          <>
            {displayName}
            <br />
          </>
        )}
        {displayDate && (
          <>
            ({displayDate})
            <br />
          </>
        )}
      </div>
    );
  }

  return (
    <a
      href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=${invNo}`}
      className={styles.RecordIcon}
      key={index}
      onClick={(event) => handleLinkClick(event, index)}
      onMouseDown={e => e.preventDefault()}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={styles.iconViewRecord}>
        {imageUrl && <ImageWithFallback src={imageUrl} alt="Image" placeholder={`${process.env.REACT_APP_IMAGE_BASE_URL}images/nondisponible.cci&width=240&height=160`} />}
        {isHovered && (
          <div className={styles.hoverOverlay}>
            <div className={styles.title}>{dataIcon(record)}</div>
            {record?.data?.Record?.Country && (
              <>
                <div className={styles.staticText}>{t("record_country")}</div>
                {Array.isArray(record?.data?.Record?.Country)
                  ? record?.data?.Record?.Country[0]?.Term ?? ''
                  : record?.data?.Record?.Country?.Term ?? ''
                }
              </>
            )}
          </div>
        )}
      </div>
    </a>
  );
};

export default RecordIcon;
